// extracted by mini-css-extract-plugin
export default {"root":"OfferSection_root__Qyd17","highlighted":"OfferSection_highlighted__REGWh","planCardWrapper":"OfferSection_planCardWrapper__ah9BY"};